import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

// レシートプリンタ（printers の receipt 行・店舗1台）の設定。
// SDP認証情報(polling_id/password)はプリンタ単位で、発行時のみ password が返る。
export default {
  getReceiptPrinter() {
    return axiosIns.get('/waiter/receipt_printer')
  },

  updateReceiptPrinter({ sdpEnabled, sdpDeviceId }) {
    const params = snakecaseKeys({ receiptPrinter: { sdpEnabled, sdpDeviceId } })

    return axiosIns.put('/waiter/receipt_printer', params)
  },

  issueSdpCredentials() {
    return axiosIns.post('/waiter/receipt_printer/issue_sdp_credentials')
  },

  // 物理1台兼用：指定キッチンプリンタの polling_id/password を共用する
  shareCredentials(sourcePrinterId) {
    return axiosIns.post('/waiter/receipt_printer/share_credentials', { source_printer_id: sourcePrinterId })
  },
}
